import { useState, useEffect } from 'react';

const usePaymentOptionsAnimation = (isSelected?: boolean) => {
  const [selectionMade, setSelectionMade] = useState(false);

  useEffect(() => {
    setSelectionMade(!!(selectionMade || isSelected));
  }, [isSelected, selectionMade]);

  return {
    playSelectedAnimation: isSelected,
    playDeselectedAnimation: selectionMade && !isSelected,
  };
};

export default usePaymentOptionsAnimation;
